import { render, staticRenderFns } from "./SingleContactSidebar.vue?vue&type=template&id=fc20b282&"
import script from "./SingleContactSidebar.vue?vue&type=script&lang=js&"
export * from "./SingleContactSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports